var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndefined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 57,
    viewBox: "0 0 40 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_71_1947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4278 0H27.1709C30.2552 0 32.752 1.00982 34.6613 3.02947C36.6195 4.99862 37.5987 7.57366 37.5987 10.7546V20.0702C37.6476 22.2918 36.3503 24.4629 33.7066 26.5836C33.5108 26.7855 32.9967 27.1642 32.1645 27.7196C31.3812 28.2245 30.8916 28.5527 30.6958 28.7042C30.451 28.8557 29.8635 29.2091 28.9333 29.7645C28.0032 30.3199 27.4157 30.6733 27.1709 30.8248L24.2335 32.6425C22.569 33.6018 21.7367 34.4602 21.7367 35.2175V37.8424C21.7367 38.275 21.386 38.6257 20.9534 38.6257H11.9454C11.5128 38.6257 11.1621 38.275 11.1621 37.8424V32.9454C11.1621 31.6832 11.7006 30.3199 12.7777 28.8557C12.9245 28.6032 13.1448 28.3255 13.4386 28.0226C13.7813 27.7196 14.124 27.4167 14.4667 27.1137C14.8094 26.8108 15.0542 26.5836 15.201 26.4321C15.9354 25.7252 16.9879 24.9931 18.3587 24.2357C18.4566 24.1852 19.5826 23.4531 21.7367 22.0394L24.4536 20.2697C24.5025 20.2378 24.5475 20.1998 24.5954 20.1664C24.6503 20.1282 24.7295 20.0816 24.833 20.0266C24.8737 20.005 24.9132 19.9802 24.9497 19.9521C26.1846 19.0023 26.8712 18.2561 27.0096 17.7134C27.0209 17.6692 27.024 17.6237 27.024 17.5781V12.8752C27.024 11.1585 26.1918 10.3002 24.5273 10.3002H13.0714C11.4069 10.3002 10.5746 11.1585 10.5746 12.8752V16.1817C10.5746 16.6143 10.2239 16.965 9.79129 16.965H0.783335C0.350712 16.965 0 16.6143 0 16.1817V10.7546C0 7.57366 0.954654 4.99862 2.86396 3.02947C4.82222 1.00982 7.34349 0 10.4278 0ZM20.9534 43.9273C21.386 43.9273 21.7367 44.278 21.7367 44.7106V54.05C21.7367 54.4826 21.386 54.8333 20.9534 54.8333H11.9454C11.5128 54.8333 11.1621 54.4826 11.1621 54.05V44.7106C11.1621 44.278 11.5128 43.9273 11.9454 43.9273H20.9534Z",
    fill: "#C30F2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_71_1947",
    x: 0,
    y: -0.783333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.783333,
    dy: 0.783333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.391667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_71_1947"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_71_1947",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.56667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.391667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_71_1947"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.783333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.783333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_71_1947",
    result: "effect3_innerShadow_71_1947"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndefined);
export default __webpack_public_path__ + "static/media/undefined.c8018fe02c45b60c7b0f0b1a69985fae.svg";
export { ForwardRef as ReactComponent };